import { api } from "../configs/apiConfig";

const userService = {
  getAllUsers: async () => {
    const response = await api.get("/User");
    return response.data;
  },

  getUserById: async (id) => {
    const response = await api.get(`/User/${id}`);
    return response.data;
  },

  getUserDetails: async (userId) => {
    const response = await api.get(`/User/${userId}/user-details`);
    return response.data;
  },

  getUserAccessiblePages: async (userId) => {
    const response = await api.get(`/AccessControl/pages/${userId}`);
    return response.data;
  },

  addUser: async (formData) => {
    try {
      const response = await api.post("/User", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      return response.data;
    } catch (error) {
      // If the error has a response with status 500 and has a meaningful message, pass it on
      if (error.response?.status === 500 && error.response?.data) {
        throw error;
      }
      // Otherwise throw a general error
      throw error;
    }
  },

  updateUser: async (id, formData) => {
    await api.put(`/User/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  },

  deleteUser: async (id) => {
    await api.delete(`/User/${id}`);
  },

  searchUsers: async (keyword) => {
    const response = await api.get("/User/search", {
      params: { keyword }
    });
    return response.data;
  },

  updateProfile: async (userId, formData) => {
    try {
      const response = await api.put(`/user/profile/${userId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default userService;
